import { AxiosRequestConfig } from "axios";
import baseApi, { version1 } from "../../Libs/Config/APIConfig";

interface CustomAxiosRequestConfig<T = unknown> extends AxiosRequestConfig<T> {}
const BaseDataConfig: CustomAxiosRequestConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiGetPatientByUniqueId = async (payload: string) => {
  return baseApi.get(`/api/${version1}/patients/get-patient-by-id/${payload}`, BaseDataConfig);
};
